import { Lightning, Utils } from '@lightningjs/sdk';
import { Theme } from '../config/theme';
import { DetailDescription } from '../pages/detail/DetailDescription';

export const _constants = {
  miniDetailHeight: 318,
  topBorderHeight: 2,
  Description: {
    marginLeft: 162,
    marginTop: 30,
  },
  PosterImage: {
    width: 740,
    height: 318,
    Gradients: {
      endPoint: 0.5,
      startColor: 0xff000000,
      endColor: Theme.Colors.Transparent,
    },
  },
};

export class MiniDetail extends Lightning.Component {
  static _template() {
    return {
      w: w => w,
      h: _constants.miniDetailHeight,
      rect: true,
      color: Theme.Colors.MiniDetail.background,
      src: Utils.asset('/images/detail/background_gradient.png'),
      TopBorder: {
        w: w => w,
        h: _constants.topBorderHeight,
        rect: true,
        color: Theme.Colors.Primary,
      },
      Content: {
        y: _constants.topBorderHeight,
        w: w => w,
        h: h => h - _constants.topBorderHeight,
        Poster: {
          flexItem: false,
          x: w => w,
          mountX: 1,
          w: _constants.PosterImage.width,
          h: _constants.PosterImage.height,
          PosterImage: {
            w: w => w,
            h: h => h,
            texture: {
              type: Lightning.textures.ImageTexture,
              src: '',
              resizeMode: {
                type: 'cover',
                w: _constants.PosterImage.width,
                h: _constants.PosterImage.height,
              },
            },
            shader: {
              type: Lightning.shaders.FadeOut,
              left: 400,
              bottom: 100,
            },
          },
        },
        DetailDescription: {
          y: _constants.Description.marginTop,
          x: _constants.Description.marginLeft,
          type: DetailDescription,
          miniDetail: true,
        },
      },
    };
  }

  set backend(backend) {
    this._backend = backend;
  }

  /**
   * @param {MiniDetailData | undefined} data
   */
  set updateUI(data) {
    const image = this.tag('PosterImage');
    // console.log(data);
    if (data?.description) this.tag('DetailDescription').content = data.description;

    if (image.src === data?.image) {
      // same image no need to refresh
    } else {
      image.alpha = 0.0001; // make image almost invisible so loading still happens
      image.texture.src = data?.image; // set new image or undefined
      image.on('txLoaded', () => {
        image.alpha = 1; // when image loaded make it fully visible
      });
    }
  }

  get height() {
    return _constants.miniDetailHeight;
  }
}
